import React, { FC } from 'react';
import { Props } from './types';
import { Container, ContentLoader } from './styles';

const Loader: FC<Props> = ({ opacity = 1 }) => {
  return (
    <Container>
      <ContentLoader
        viewBox="0 0 400 30"
        backgroundColor="#f1f1f1"
        $opacity={opacity}
      >
        <rect x="10" y="4" rx="4" ry="4" width="45" height="7" />
        <rect x="10" y="15" rx="3" ry="3" width="25" height="6" />

        <circle cx="107" cy="11" r="9" />
        <rect x="123" y="8" rx="4" ry="4" width="30" height="7" />

        <circle cx="195" cy="11" r="9" />
        <rect x="208" y="4" rx="4" ry="4" width="45" height="7" />
        <rect x="208" y="15" rx="3" ry="3" width="25" height="6" />

        <rect x="274" y="8" rx="3" ry="3" width="28" height="6" />

        <rect x="324" y="2" rx="8" ry="8" width="39" height="17" />
        <circle cx="383" cy="11" r="9" />
      </ContentLoader>
    </Container>
  );
};

export default Loader;
